import './TeamExperience.css'
const TeamExperience = ({title, description}) => {
    return (
        <>

            <li className={"team-experience-detail-container"}>
                <h2 className={"team-experience-title"}><strong>{title}</strong></h2>
                <p className={"team-experience-description"}>
                    {description}
                </p>
            </li>
        </>
    )
}

export default TeamExperience;
